var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "stream" },
    [
      _c(
        "div",
        { staticClass: "stream-head" },
        [
          _c("StreamName", {
            staticClass: "stream__name",
            attrs: { "is-access-allow": _vm.isAccessAllow },
          }),
          _vm._v(" "),
          _c("StreamObject", {
            staticClass: "stream__object",
            attrs: { "is-access-allow": _vm.isAccessAllow },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "StageListTable",
        { staticClass: "stream__stage-list" },
        _vm._l(_vm.stages, function (stage) {
          return _c("SubtaskStage", {
            key: stage.id,
            attrs: { stage: stage, "is-access-allow": _vm.isAccessAllow },
            on: {
              updateStage: (newStage) => _vm.updateStage(newStage),
              deleteStage: function ($event) {
                return _vm.deleteStage(stage.id)
              },
            },
          })
        }),
        1
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "stream__stage-errors",
        domProps: { innerHTML: _vm._s(_vm.stagesErrors.join("<br>\n")) },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "stream-foot" }, [
        _c(
          "div",
          { staticClass: "stream__agent" },
          [
            _c("span", { staticClass: "stream-foot__key" }, [_vm._v("Агент:")]),
            _vm._v(" "),
            _vm.isAccessAllow
              ? _c("StreamAgent", { staticClass: "stream-foot__value" })
              : _c("p", { staticClass: "stream-url" }, [
                  _vm._v(_vm._s(_vm.stream.agent)),
                ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "stream__url" },
          [
            _c("span", { staticClass: "stream-foot__key" }, [
              _vm._v("Ссылка:"),
            ]),
            _vm._v(" "),
            _vm.isAccessAllow
              ? _c("StreamUrl", {
                  staticClass: "stream-foot__value",
                  on: { error: (v) => (_vm.stagesErrors = [v]) },
                })
              : _c("p", { staticClass: "stream-url" }, [
                  _vm._v(_vm._s(_vm.stream.url)),
                ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "stream__screenshot" },
          [
            _c("span", { staticClass: "stream-foot__key" }, [
              _vm._v("Скриншот:"),
            ]),
            _vm._v(" "),
            _c("StreamScreenshot", {
              staticClass: "stream-foot__value",
              attrs: {
                "is-access-allow": _vm.isAccessAllow,
                streamId: _vm.stream.id,
                value: _vm.stream.screenshot,
                safe: _vm.stream.screenshot_safe,
              },
              on: { error: (v) => (_vm.stagesErrors = [v]) },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "stream__content" },
        [
          _c("h3", { staticClass: "stream-content__label" }, [
            _vm._v("Контент"),
          ]),
          _vm._v(" "),
          _vm.isAccessAllow
            ? _c("StreamContent", { staticClass: "stream-foot__value" })
            : _c("p", { staticClass: "stream-content" }, [
                _vm._v(_vm._s(_vm.stream.content || "контента нет")),
              ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }